import Fetch from '@/api';
import VM from '../../main';
// import videoService, { videoConst } from '@zyf2e/rtcpc/lib/video-service';
//
// const { SERVER_LOG, ERoomStatus } = videoConst;

let callInterval;
const state = {
  isStartLocalCamera: false, // 本地摄像头是否打开
  isBeCalling: false, // 是否正在被呼叫
  isCallLoading: false, // 是否呼叫加载中？
  isCallAccepted: false, // 是否呼叫被接受
  isCallReceived: false, // 是否呼叫被接受
  callDuration: 0, // 呼叫时长
  shrink: false, // 缩放
  videoWarningInfo: {
    // 视频警告信息
    show: false, // 展示啥？
    remaining: 15, // 剩余啥？
    message: '单次视频不可超过10分钟'
  },
  isCalledUserInfo: {}, // 被呼叫的用户信息
  videoInfo: {
    userInfo: {},
    type: 1, // 1:联系药店 //视频咨询，默认是1
    custom: ''
  },
  recordVideoInfo: {} // 记录视频信息
};
const mutations = {
  // 初始化状态
  INIT_STATUS(state) {
    // 提交变更
    state.isStartLocalCamera = false; // 初始化摄像头的是关闭的
    state.isCallAccepted = false;
    state.isBeCalling = false;
    state.isCallLoading = false;
    state.isCallReceived = false;
    state.callDuration = 0;
    // 因为有动画效果，所以延迟设置
    setTimeout(() => {
      state.shrink = false;
    }, 1000);
    clearInterval(callInterval);
  },
  SET_WEBRTC_STATUS(state, data) {
    const { key, value } = data;
    state[key] = value;
  },
  // 设置视频信息
  SET_VIDEO_INFO(state, data) {
    state.videoInfo = { ...state.videoInfo, ...data };
  },
  // 设置视频警告框
  SET_VIDEO_WARNING(state, data) {
    state.videoWarningInfo = { ...state.videoWarningInfo, ...data };
  },
  // 初始化记录视频信息
  INIT_RECORD_VIDEO(state, data) {
    state.recordVideoInfo = {
      channelId: '',
      error: ''
    };
  },
  // 设置录制视频
  SET_RECORD_VIDEO_INFO(state, data) {
    state.recordVideoInfo = { ...state.recordVideoInfo, ...data };
  },
  SET_SHRINK(state, shrink) {
    state.shrink = shrink;
  }
};

const actions = {
  // async init({ commit, state, dispatch }, webRtc) {
  //   if (!webRtc) return;
  //   // 是否成功发起视频
  //   webRtc.on('callReceived', obj => {
  //     console.log('callReceived');
  //     // 因为一些账号回调有问题，所以事件处理放在了发起视频成功里面
  //   });
  //   webRtc.on('hideAllWebrtcUI', obj => {
  //     console.log('hideAllWebrtcUI');
  //     dispatch('setVideoInital');
  //   });
  //   // 监听云信自己的hangUp事件，只有被挂断者才会触发
  //   webRtc.webrtc.once('hangup', obj => {
  //     console.log('hangup', obj);
  //     dispatch('recordVideoInfo', { ...state.recordVideoInfo, endUserId: obj.account, action: 'end' });
  //     videoService.PubSub.publish(SERVER_LOG.UPDATE_ROOM_STATUS_NERTCV1, { roomStatus: ERoomStatus.end });
  //   });
  //   // 被呼叫
  //   webRtc.on('beCalling', obj => {
  //     console.log(obj, '被呼叫');
  //     commit('SET_WEBRTC_STATUS', { key: 'isBeCalling', value: true });
  //     commit('SET_WEBRTC_STATUS', { key: 'isCallLoading', value: true });
  //   });
  //   // 通话被接听
  //   webRtc.on('callAccepted', obj => {
  //     if (!state.isBeCalling) {
  //       dispatch('video_trtcVideoStore/updateNertcv1RoomId', { roomId: obj.channelId }, { root: true });
  //     }
  //     console.log('callAccepted');
  //     // 接受通话，都会触发
  //     commit('SET_WEBRTC_STATUS', { key: 'isCallAccepted', value: true });
  //     commit('SET_WEBRTC_STATUS', { key: 'isCallLoading', value: false });
  //     if (callInterval) clearInterval(callInterval);
  //     callInterval = setInterval(() => {
  //       state.callDuration++;
  //       commit('SET_WEBRTC_STATUS', { key: 'callDuration', value: state.callDuration });
  //       commit('SET_RECORD_VIDEO_INFO', { videoTime: state.callDuration });
  //     }, 1000);
  //     dispatch('recordVideoInfo', { channelId: obj.channelId, action: 'connect' });
  //     videoService.PubSub.publish(SERVER_LOG.UPDATE_ROOM_STATUS_NERTCV1, { roomStatus: ERoomStatus.ongoing });
  //   });
  //   // 通话被拒绝
  //   webRtc.on('callRejected', obj => {
  //     console.log('对方拒绝接听', obj);
  //     dispatch('recordVideoInfo', { endUserId: obj.account, action: 'end' });
  //     videoService.PubSub.publish(SERVER_LOG.UPDATE_ROOM_STATUS_NERTCV1, { roomStatus: ERoomStatus.end });
  //     dispatch('INIT_STATUS');
  //   });
  //   // 被其他设备监听
  //   webRtc.on('callerAckSync', obj => {
  //     console.log('其他设备已做处理');
  //     dispatch('INIT_STATUS');
  //   });
  //   webRtc.on('error', error => {
  //     console.log('error', error);
  //     videoService.PubSub.publish(SERVER_LOG.UPDATE_ROOM_STATUS_NERTCV1, { roomStatus: ERoomStatus.error });
  //
  //     if (state.isCallReceived) {
  //       dispatch('recordVideoInfo', { error, action: 'end' });
  //     }
  //     dispatch('INIT_STATUS');
  //   });
  //   webRtc.on('startCallOverTime', obj => {
  //     videoService.PubSub.publish(SERVER_LOG.UPDATE_ROOM_STATUS_NERTCV1, { roomStatus: ERoomStatus.end });
  //     console.log('超时startCallOverTime');
  //     dispatch('recordVideoInfo', { endUserId: 0, action: 'end' });
  //     // if (state.isCallReceived) {
  //
  //     // }
  //   });
  //   return Promise.resolve(webRtc);
  // },
  setVideoInfo({ commit }, data) {
    commit('SET_VIDEO_INFO', data);
  },
  setVideoWarning({ commit }, data) {
    commit('SET_VIDEO_WARNING', data);
  },
  selfEndVideo({ commit, dispatch, state }) {
    const { type } = state.videoInfo;
    if (type == 1) {
      setTimeout(() => {
        VM.$confirm('单次视频不能超过10分钟，如有需要请再次发起视频', '视频不能超过10分钟', {
          distinguishCancelAndClose: true,
          customClass: 'confirm',
          showClose: false,
          confirmButtonText: '知道了',
          cancelButtonText: '再次发起',
          center: true
        })
          .then(() => {
            console.log('删除成功');
          })
          .catch(action => {
            console.log('已取消删除', action);
            if (action == 'cancel') dispatch('prescription/contactStore', '', { root: true });
          });
      }, 1000);
    }
  },
  startVideoSuccessCb({ commit }) {
    console.log('startVideo成功');
    commit('SET_WEBRTC_STATUS', { key: 'isCallReceived', value: true });
    commit('SET_WEBRTC_STATUS', { key: 'isCallLoading', value: true });
    const { name, toAccount } = state.videoInfo.userInfo;
    if (toAccount && name) {
      Fetch.push_ios_voip_message({ submitName: name, shopUserId: toAccount });
    }
  },
  async setVideoInital({ commit, dispatch, rootState }) {
    commit('INIT_STATUS');
    // 获取当前存在的webRtc
    const webRtc = rootState.webRtc.__webRtc ? rootState.webRtc.__webRtc : '';
    webRtc && webRtc.stopVideoPreview && webRtc.stopVideoPreview();
  },
  // 设置录制视频
  setRecordVideoInfo({ commit }, data) {
    commit('SET_RECORD_VIDEO_INFO', data);
  },
  // 录制视频
  async recordVideoInfo({ commit, dispatch, state }, data) {
    try {
      dispatch('setRecordVideoInfo', data || {});
      const params = { ...state.recordVideoInfo };
      if (params.videoTime) params.videoTime = params.videoTime * 1000;
      await Fetch.record_video(params);
    } catch (error) {}
  }
};

const getters = {
  recordVideoInfoAction: state => {
    return state.recordVideoInfo.action;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
